import React, { useState } from "react";
import { Button, Container, Row, Col, Card, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { collection, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";

const WelcomeUser = () => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);

  const handleViewResults = () => {
    history.push("/user/home");
  };

  const handleTakeTest = async () => {
    try {
      history.push("/user/test");
      setShowModal(true);
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'email:", error);
    }
  };

  const handleRequestNewTest = async () => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    const userId = localStorage.getItem("userIdStorage");
    const firstName = localStorage.getItem("firstName");
    const lastName = localStorage.getItem("lastName");
    const userData = {
      email: currentUser.email,
      userId: userId,
      firstName: firstName,
      lastName: lastName,
    };

    //enregistrer les infos user dans le document notifications avec un status "pending"
    const docRef = doc(collection(db, "notifications"), userId);
    await setDoc(docRef, {
      userId: userId,
      email: currentUser.email,
      firstName: firstName,
      lastName: lastName,
      status: "pending",
    });
    
    setShowModal(true);
  }

  return (
    <>
      <Container fluid>
        <Row className="justify-content-center mt-5">
          <Col md="8">
            <Card>
              <Card.Body className="text-center">
                <h3 className="mb-4">Que voulez-vous faire aujourd'hui ?</h3>
                <div className="d-grid gap-3">
                  {/* <Button
                    variant="primary"
                    size="lg"
                    onClick={handleViewResults}
                    className="text-white">
                    Voir mes résultats
                  </Button> */}
                  <div
                    style={{
                      margin: "20px 0",
                    }}
                />
                       <Button
                    variant="primary"
                    size="lg"
                    onClick={handleTakeTest}
                    className="text-white">
                    Accéder au questionnaire
                    </Button>

                  <div
                    style={{
                      margin: "20px 0",
                    }}
                />
                       <Button
                    variant="outline-light"
                    size="lg"
                    onClick={handleRequestNewTest}
                    style={{
                      color: "#ce9136",
                      borderColor: "#ce9136",
                      marginBottom: "20px"
                    }}
                    className="text-white">
                    <span style={{color: "#ce9136"}} >Demander un nouveau questionnaire</span>
                  </Button>
                </div>
                
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Demande envoyée</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>
              Votre demande pour passer un nouveau questionnaire a bien été
              envoyée à l'administrateur. Vous serez informé(e) dès qu'elle aura
              été traitée.
            </p>
            <p>
              (Si votre demande a déjà été prise en compte, merci de ne pas
              tenir compte de ce message.)
            </p>
          </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowModal(false)}>
            <span style={{color: "#ffffff"}}>Fermer</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WelcomeUser;
